import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export type TAccountsTable = TAccountsRow[];

export type TAccountsRow = {
  accountType: Nullable<string>;
  whoIsThePrimaryAccountOwner: Nullable<string>;
  yourName: Nullable<string>;
  doYouOwnThisAccountByYourselfOrIsItAJointAccount: Nullable<string>;
  whoIsTheJointOwner: Nullable<string>;
  spouseName: Nullable<string>;
  doYouHaveSignatoryAuthorityjoinOwnership: Nullable<string>;
  theirName: Nullable<string>;
  whatIsYourRelationshipToTheAccountOwner: Nullable<string>;
  theirSsifAvailable: Nullable<string>;
  theirAddress: Nullable<string>;
  accountNicknameoptional: Nullable<string>;
  nameOfFinancialInstitutionInWhichAccountIsHeld: Nullable<string>;
  accountNumber: Nullable<string>;
  highestBalanceDuringTheYear: Nullable<string>;
  addressOfFinancialInstitutionInWhichTheAccountIsHeldstreetAddress: Nullable<string>;
  city: Nullable<string>;
  stateOrProvincemexicoAndCanadaOnly: Nullable<string>;
  postCode: Nullable<string>;
  country: Nullable<string>;
  wasTheAccountOpenedDuringTheTaxYear: Nullable<TYesOrNo>;
  wasTheAccountClosedDuringYear: Nullable<TYesOrNo>;
};

export interface AccountsListStateValues {
  accountsTable: TAccountsTable;
}

export interface AccountsListState {
  values: AccountsListStateValues;
}

const initialState: AccountsListState = {
  values: {
    accountsTable: [
      {
        accountType: null,
        whoIsThePrimaryAccountOwner: null,
        yourName: null,
        doYouOwnThisAccountByYourselfOrIsItAJointAccount: null,
        whoIsTheJointOwner: null,
        spouseName: null,
        doYouHaveSignatoryAuthorityjoinOwnership: null,
        theirName: null,
        whatIsYourRelationshipToTheAccountOwner: null,
        theirSsifAvailable: null,
        theirAddress: null,
        accountNicknameoptional: null,
        nameOfFinancialInstitutionInWhichAccountIsHeld: null,
        accountNumber: null,
        highestBalanceDuringTheYear: null,
        addressOfFinancialInstitutionInWhichTheAccountIsHeldstreetAddress: null,
        city: null,
        stateOrProvincemexicoAndCanadaOnly: null,
        postCode: null,
        country: null,
        wasTheAccountOpenedDuringTheTaxYear: null,
        wasTheAccountClosedDuringYear: null,
      },
    ],
  },
};

const accountsListSlice = createSlice({
  name: 'accountsList',
  initialState,
  reducers: {
    update(state, action: PayloadAction<AccountsListStateValues>) {
      state.values = JSON.parse(JSON.stringify(action.payload));
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof AccountsListStateValues | keyof TAccountsRow;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key: keyof AccountsListStateValues | keyof TAccountsRow;
        value: TAccountsTable;
      }>,
    ) {
      const fieldArray = action.payload.value.map((field) => ({ ...field }));
      if (action.payload.key === 'accountsTable') {
        state.values[action.payload.key] = fieldArray;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.nonUsFinancialAccounts
              .accountsList.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  accountsListSlice.actions;
export default accountsListSlice.reducer;

export const selectAccountsList = (state: RootState) =>
  state.taxQuestionnaire.nonUsFinancialAccounts.accountsList;
